// Analytics: eb-ui used `@eventbrite/site-analytics`
// (`trackEventFromState(props, {category, action, label})`) but only fired for
// visitors arriving from a search engine. Per harness/memory.md, GA is deprecated in
// favour of Heap. We preserve the search-engine gate and dispatch to Heap (the
// sanctioned vehicle), guarded so it no-ops when Heap isn't loaded — exactly as the
// eb-ui site-analytics transport guarded itself. The category/action/label come
// straight from the eb-ui source (the semantics oracle), not invented.

interface HeapLike {
    track: (event: string, properties?: Record<string, unknown>) => void;
}

declare global {
    // eslint-disable-next-line no-var
    interface Window {
        heap?: HeapLike;
    }
}

/** True when the referrer is a search engine (google/bing/yahoo) — eb-ui's gate. */
export function httpRefererWasSearchEngine(httpReferer: string): boolean {
    return (httpReferer || '').search(/google|bing|yahoo/) >= 0;
}

export interface TrendingAnalyticsEvent {
    category: string;
    action: string;
    label: string;
}

export function trackTrendingEvent(event: TrendingAnalyticsEvent): void {
    if (typeof window === 'undefined' || !window.heap) return;
    window.heap.track(event.action, {
        category: event.category,
        label: event.label,
    });
}
